<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-06 17:51:49
 * @Description: 
-->
<template>
	<div>
		<NavBar
			:title="$t(`webapp.menus.${$route.meta.field}`)"
			:left-arrow="$route.meta.isShowArrow"
			@click-left="$router.back()"
			nav-bar-icon-color="#000"
			class="navbarSelf"
		></NavBar>
		<div class="box">
			<div class="top">
				<Icon :name="status == 1 ? 'checked' : 'clear'" size="25" :color="status == 1 ? '#52C41A' : '#FF0000'" />
				<div class="title">{{ status == 1 ? $t("webapp.password.set_success") : $t("webapp.password.set_failure") }}</div>
				<div class="remark">{{ count }}s {{ $t("webapp.password.auto_tip") }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Icon, NavBar } from "vant";

export default {
	name: "WarnPassword",
	components: { Icon, NavBar },
	data() {
		return { status: "", count: 5 };
	},
	async created() {
		// 移除 localStorage
		localStorage.removeItem("FORGET_INFO");
		this.status = this.$route.query.status;
		// 开启倒计时
		const timer = setInterval(() => {
			if (this.count >= 1) {
				this.count--;
			} else {
				this.$router.push("/mlogin");
				clearInterval(timer);
			}
		}, 1000);
	},
	methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base.scss";
.box {
	background: #fff;
	margin: 10px 15px;
	text-align: center;
	border-radius: 8px;
	height: 500px;
	.top {
		padding-top: 100px;
	}
	.title {
		font-size: 16px;
		font-weight: 600;
		color: #000000;
		line-height: 40px;
	}
	.remark {
		color: #9f9f9f;
	}
}
</style>
